import * as React from 'react';

const BookmarkSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        className="bookmark_svg__eds-icon--bookmark_svg"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            className="bookmark_svg__eds-icon--bookmark_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 3h12v16.9l-6-4.7-6 4.7V3zM5 2v20l7-5.5 7 5.5V2H5z"
        />
    </svg>
);

BookmarkSvg.displayName = 'BookmarkSvg';
export default BookmarkSvg;
